import type { ReactNode } from 'react';

type Props = {
  title?: string;
  onClose: () => void;
  onSave?: () => void;
  isSaving?: boolean;
  children: ReactNode;
};

/** Bootstrap 3 modal markup rendered by React (bootstrap JS is not loaded). Static backdrop, like legacy. */
export const ModalDialog = ({ title = 'Modal', onClose, onSave, isSaving, children }: Props) => (
  <>
    <div className="modal-backdrop fade in" />
    <div className="modal fade in" style={{ display: 'block' }} role="dialog" tabIndex={-1}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title">{title}</h4>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default pull-left" onClick={onClose}>
              Отмена
            </button>
            {onSave && (
              <button type="button" className="btn btn-primary" onClick={onSave} disabled={isSaving}>
                Сохранить
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  </>
);
